import { useMemo } from 'react';
import { FooterButtonProps } from './types';
import BUTTON_TYPES from './list';

const FooterButton = (props: FooterButtonProps<any>) => {
  const { btnDef } = props;
  const style = useMemo(() => {
    const _style: React.CSSProperties = { justifySelf: 'flex-start' };
    switch (btnDef.align) {
      case 'left':
        _style.justifySelf = 'flex-start';
      case 'right':
        _style.justifySelf = 'flex-end';
      case 'center':
        _style.justifySelf = 'center';
      default:
    }

    return _style;
  }, [btnDef]);

  const ButtonComponent = BUTTON_TYPES[btnDef.type] ?? BUTTON_TYPES.default;
  return <ButtonComponent {...props} style={style} size="sm" />;
};

export default FooterButton;
